import React, { FC } from "react";
import { useCallback } from "react";
import Bookmarks from "@material-ui/icons/Bookmarks";
import Class from "@material-ui/icons/Class";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import Work from "@material-ui/icons/Work";
import Category from "@material-ui/icons/Category";
import School from "@material-ui/icons/School";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import { useHistory } from "react-router";
import FontIcon from "../../../../components/FontIcon";
import { SpeedDialIcon } from "@material-ui/lab";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

const useStyles = makeStyles((theme: Theme) => ({
  speedDial: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

const actions = [
  {
    icon: <School />,
    name: "Degree",
    href: "/0/degree/create",
  },
  {
    icon: <Class />,
    name: "Exam",
    href: "/0/exam/create",
  },
  {
    icon: <Bookmarks />,
    name: "Major",
    href: "/0/major/create",
  },
  {
    icon: <FontIcon name="school" />,
    name: "School",
    href: "/0/school/create",
  },
  {
    icon: <Work />,
    name: "Academics",
    href: "/0/academics/create",
  },
  {
    icon: <Category />,
    name: "Service",
    href: "/0/service/create",
  },
  {
    icon: <PeopleAlt />,
    name: "User",
    href: "/0/user",
  },
];
const DashboardFab: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);

  const handleClose = useCallback((e) => {
    if (e.type === "click") setOpen(false);
  }, []);

  const handleOpen = useCallback((e) => {
    if (e.type === "click") setOpen(true);
  }, []);

  const handleClick = useCallback((e, action) => {
    history.push(action.href);
    handleClose(e);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <SpeedDial
        ariaLabel="SpeedDial"
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction={"up"}
      >
        {actions.map((action) => (
          <SpeedDialAction
            tooltipOpen
            key={action.name}
            icon={action.icon}
            title={action.name}
            tooltipTitle={action.name}
            onClick={(e) => handleClick(e, action)}
          />
        ))}
      </SpeedDial>
    </ClickAwayListener>
  );
};

export default React.memo(DashboardFab);
